import axios from 'axios';

const state = {
  webViewerFileData: [],
  requestedFile: null,
  openFile: null,
  processingFiles: [],
};


const getters = {
  getCardRef: (state, getters, rootState, rootGetters) => rootGetters['cards/getCardRef'],
  // prioritizedRecentlyOpenedFiles: (state) => {
  //   // Not used at the moment, but keeping it in case you want to use this algorithm later
  //   // You do need recentlyOpenedFiles and loadedFiles in state (or replace it by something else)
  //   const prioritizedRecentlyOpenedFiles = [];
  //   state.recentlyOpenedFiles && state.recentlyOpenedFiles.forEach(({ cardId, filename, firstOpened, timeSpend, leftByClosingCard }) => {
  //     const now = Date.now();
  //     const timeSinceFirstOpened = now - firstOpened;

  //     let score = timeSpend === 0
  //       ? timeSinceFirstOpened / timeSinceFirstOpened // If timeSpend equals 0, we haven't left the file yet, so timeSpend is equal to timeSinceFirstOpened (so the ratio is 1)
  //       : timeSpend / timeSinceFirstOpened;
  //     if (leftByClosingCard) score *= 0.1;

  //     const isOpen = state.loadedFiles && !!state.loadedFiles.find(entry => entry.cardId === cardId);

  //     prioritizedRecentlyOpenedFiles.push({
  //       cardId,
  //       filename,
  //       score,
  //       scoreParams: { timeSinceFirstOpened, timeSpend },
  //       isOpen,
  //     });
  //   });
  //   prioritizedRecentlyOpenedFiles.sort((a, b) => b.score - a.score);

  //   return prioritizedRecentlyOpenedFiles;
  // },
  userId: (state, getters, rootState, rootGetters) => rootGetters['users/userId'],
};

const actions = {
  modifyFileKey({ state, dispatch }, { cardId, relatedCollectionId, filename, newCollectionId, newFilename }) {
    return new Promise(async (resolve, reject) => {
      // A little cumbersome for now, there probably is a better solution. But it works.

      // Moving between collections
      if (newCollectionId) {
        const file = await dispatch('getFile', { cardId, relatedCollectionId, filename });
        const fileData = new FormData();
        fileData.append('card-item', file);

        // First upload to new collection folder, then delete old one
        axios.post(`files/${newCollectionId}/${cardId} - ${filename}`, fileData, { headers: { 'Content-Type': 'multipart/form-data' } })
          .then((res) => {
            axios.delete(`files/${relatedCollectionId}/${cardId} - ${filename}`)
              .then(() => {
                resolve();
              })
              .catch((err) => {
                reject(err);
              });
          })
          .catch((err) => {
            reject(err);
          });
      }
      // Changing file name
      else if (newFilename) {
        reject(new Error('Changing file name not implemented yet!'));
      }
    });
  },
  getFile({ state }, { cardId, relatedCollectionId, filename }) {
    return new Promise((resolve, reject) => {
      axios.get(`files/${relatedCollectionId}/${cardId} - ${filename}`)
        .then((res) => {
          const blob = new Blob([new Uint8Array(res.data.fileBuffer.data, 0, res.data.fileBuffer.length)], { type: 'application/pdf' });
          resolve(blob);
        })
        .catch((err) => {
          console.error('Error in getFile: ', err);
          reject(err);
        });
    });
  },
  uploadFile({ state, getters, dispatch, commit }, { cardId, relatedCollectionId, filename, fileData, file, cardHasTempId, replace = false }) {
    return new Promise((resolve, reject) => {
      if (fileData.size > 52428800) {
        reject(new Error('Maximum file size exceeded!'));
        return;
      }

      axios.post(`files/${relatedCollectionId}/${cardId} - ${filename}`, fileData, { headers: { 'Content-Type': 'multipart/form-data' } })
        .then((res) => {
          // Replace is used only for uploading files without annotations, after having extracted them and put them in db. So nothing needs to be modified further.
          if (replace) {
            resolve();
            return;
          }

          // If this concerns a new card, we should use the id of 0 since Vuex will not be updated yet
          let id = cardId;
          if (cardHasTempId) id = 0;

          dispatch('cards/modifyCards', {
            cards: [{
              action: 'update',
              id,
              data: {
                item: {
                  type: 'file',
                  address: filename,
                  displayName: filename,
                  inFileAnnotationsProcessed: false,
                },
              },
            }],
          }, { root: true });

          resolve();
        })
        .catch((err) => {
          reject(err);
        });

      if (!cardHasTempId && !replace) {
        // If we have a cardId already, add to webViewerFileData
        const webViewerFileDataObj = {
          cardId,
          ref: getters.getCardRef({ cardId, relatedCollectionId }),
          doc: file,
          annots: [],
          zoomLevel: null,
          scrollLeft: null,
          scrollTop: null,
        };

        if (!replace) commit('AddToWebViewerFileData', webViewerFileDataObj);
      }
    });
  },
  deleteFile({ state, commit }, { cardId, relatedCollectionId, filename, replace = false }) {
    return new Promise((resolve, reject) => {
      axios.delete(`files/${relatedCollectionId}/${cardId} - ${filename}`)
        .then((res) => {
          // If it is a replace action (used when a file is stripped from its annotations to save them in db), no need to remove from filedata or history
          if (!replace) {
            commit('RemoveFromWebViewerFileData', cardId);
            commit('appState/DeleteFromHistory', `/item/${cardId}`, { root: true });
          }
          resolve();
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  replaceFile({ state, dispatch, commit }, { cardId, relatedCollectionId, filename, blob }) {
    return new Promise(async (resolve, reject) => {
      if (blob.size > 52428800) {
        reject(new Error('Maximum file size exceeded!'));
        return;
      }

      // In webViewerFileData
      commit('ReplaceFileInWebViewerFileData', { cardId, blob });

      const fileData = blob;
      try {
        await dispatch('deleteFile', { cardId, relatedCollectionId, filename, replace: true });
        await dispatch('uploadFile', { cardId, relatedCollectionId, filename, fileData, replace: true });
        resolve();
      }
      catch (err) {
        reject(err);
      }
    });
  },
  deleteAllFilesInCollection({ state, dispatch, commit, rootState }, relatedCollectionId) {
    return new Promise(async (resolve, reject) => {
      // BETTER DESIGN: just delete the whole folder on the server. This is still from when I hosted stuff in AWS buckets. But too much effort to change for now xD
      const cards = rootState.cards.cards[relatedCollectionId];
      if (!cards) {
        resolve();
        return;
      }

      const promises = [];
      const itemsToCleanUp = [];
      cards.forEach((card) => {
        if (card.item && card.item.type === 'file') {
          promises.push(dispatch('deleteFile', { cardId: card.id, relatedCollectionId, filename: card.item.address }));
          itemsToCleanUp.push(card.id);
        }
      });

      await Promise.all(promises);

      itemsToCleanUp.forEach((id) => {
        commit('RemoveFromWebViewerFileData', id);
        commit('appState/DeleteFromHistory', `/item/${id}`, { root: true });
      });
      resolve();
    });
  },
  addWebViewerFileData({ state, dispatch, commit }, card) {
    return new Promise(async (resolve, reject) => {
      const { id: cardId, relatedCollectionId } = card;

      const fileDataIsAvailable = !!state.webViewerFileData.find(entry => entry.cardId === cardId && entry.doc);
      const fileDataIsBeingAdded = !!state.processingFiles.find(id => id === cardId);
      if (fileDataIsAvailable || fileDataIsBeingAdded) {
        resolve();
        return;
      }

      // Save that we're loading this file, to prevent double loading (happens when items are loaded due to being pinned, but also clicked on quickly after startup)
      commit('StartedProcessingFile', cardId);

      if (!card.item || (card.item && card.item.type !== 'file')) {
        reject(new Error('Error: cannot find requested file'));
        return;
      }

      const webViewerFileDataObj = {
        cardId,
        ref: card,
        doc: null,
        annots: null,
        zoomLevel: null,
        scrollLeft: null,
        scrollTop: null,
      };

      commit('AddToWebViewerFileData', webViewerFileDataObj);

      const [doc, annots] = await Promise.all([
        dispatch('getFile', { cardId, relatedCollectionId, filename: card.item.address }),
        dispatch('getAnnotations', { cardId }),
      ]);

      const webViewerFileDataUpdateObj = {
        cardId,
        doc,
        annots,
      };

      commit('UpdateWebViewerFileData', webViewerFileDataUpdateObj);
      commit('DoneProcessingFile', cardId);
      resolve();
    });
  },
  openInWebViewer({ state, dispatch, commit }, card) {
    return new Promise(async (resolve, reject) => {
      const { id: cardId } = card;
      commit('SetRequestedFile', cardId);
      const { openFile } = state;

      await dispatch('addWebViewerFileData', card);
      // Check whether the file that was open at the start of this request is still open. If so, we have not navigated to another file while we were getting this file.
      // Also check whether the requestedFile is still this file. If not, there is no need to open this file in WebViewer.
      if (state.openFile === openFile && state.requestedFile === cardId) {
        commit('OpenInWebViewer', cardId);
        resolve();
      }
      else reject();
    });
  },
  getAnnotations({ dispatch, getters }, { cardId, collectionId }) {
    return new Promise((resolve, reject) => {
      if (!cardId && !collectionId) {
        dispatch('notifications/setError', { error: 'Error: not specified which annotations to retrieve' }, { root: true });
        return;
      }

      const source = cardId ? 'card' : 'collection';
      axios.get(`annotations/${getters.userId}/${source}/${cardId || collectionId}`)
        .then(res => resolve(res.data))
        .catch(err => reject(err));
    });
  },
  processAnnotations({ dispatch, commit }, { cardId, relatedCollectionId, annotationId, xfdfString, action }) {
    if (!cardId || !relatedCollectionId || !annotationId) {
      dispatch('notifications/setError', { error: 'Error: failed to process annotation' }, { root: true });
      return;
    }

    const isDeleteCommand = action === 'delete'; // || /(?:<delete>)([.\s\S]*)(?:<\/delete>)/gm.test(xfdfString);
    const isModifyCommand = action === 'modify'; // || /(?:<modify>)([.\s\S]*)(?:<\/modify>)/gm.test(xfdfString);
    const isAddCommand = action === 'add'; // || /(?:<add>)([.\s\S]*)(?:<\/add>)/gm.test(xfdfString);

    if (!isDeleteCommand && !isModifyCommand && !isAddCommand) {
      dispatch('notifications/setError', { error: 'Cannot process annotation (unknown action)' }, { root: true });
      return;
    }

    // Locally
    if (isDeleteCommand) commit('DeleteAnnotation', { cardId, annotationId });
    else if (isModifyCommand) commit('ModifyAnnotation', { cardId, annotationId, xfdfString });
    else if (isAddCommand) commit('AddAnnotation', { cardId, relatedCollectionId, annotationId, xfdfString });

    // Sync
    dispatch('sync/enqueueAnnotation', { annotationId, cardId, relatedCollectionId, xfdfString, action }, { root: true });
    // dispatch('sync/persistAnnotations', null, { root: true }); // Not sure why I presist immediately here
  },
  deleteAnnotations({ getters }, cardId) { // This is per card, deleting individual annotations is via processAnnotations
    return new Promise((resolve, reject) => {
      if (!cardId) {
        reject(new Error('Specification lacking'));
        return;
      }

      axios.delete(`annotations/${getters.userId}/card/${cardId}`)
        .then(() => resolve())
        .catch(err => reject(err));
    });
  },
};

const mutations = {
  AddToWebViewerFileData(state, webViewerFileDataObj) {
    state.webViewerFileData.push(webViewerFileDataObj);
  },
  ReplaceFileInWebViewerFileData(state, { cardId, blob }) {
    const index = state.webViewerFileData.findIndex(entry => entry.cardId === cardId);
    if (index >= 0) state.webViewerFileData[index].doc = blob;
  },
  RemoveFromWebViewerFileData(state, cardId) {
    const index = state.webViewerFileData.findIndex(entry => entry.cardId === cardId);
    if (index >= 0) state.webViewerFileData.splice(index, 1);
  },
  UpdateWebViewerFileData(state, { cardId, zoomLevel, scrollLeft, scrollTop, doc, annots }) {
    const index = state.webViewerFileData.findIndex(entry => entry.cardId === cardId);
    if (index >= 0) {
      state.webViewerFileData[index].zoomLevel = zoomLevel;
      state.webViewerFileData[index].scrollLeft = scrollLeft;
      state.webViewerFileData[index].scrollTop = scrollTop;
      if (doc) state.webViewerFileData[index].doc = doc;
      if (annots) state.webViewerFileData[index].annots = annots;
    }
  },
  OpenInWebViewer(state, cardId) {
    state.openFile = cardId;
  },
  SetRequestedFile(state, cardId) {
    state.requestedFile = cardId;
  },
  ResetRequestedAndOpenFile(state) {
    state.openFile = null;
    state.requestedFile = null;
  },
  DeleteAnnotation(state, { cardId, annotationId }) {
    const cardIndex = state.webViewerFileData.findIndex(entry => entry.cardId === cardId);
    const annotIndex = state.webViewerFileData[cardIndex].annots.findIndex(annot => annot.annotationId === annotationId);
    state.webViewerFileData[cardIndex].annots.splice(annotIndex, 1);
  },
  ModifyAnnotation(state, { cardId, annotationId, xfdfString }) {
    const cardIndex = state.webViewerFileData.findIndex(entry => entry.cardId === cardId);
    const annotIndex = state.webViewerFileData[cardIndex].annots.findIndex(annot => annot.annotationId === annotationId);
    state.webViewerFileData[cardIndex].annots[annotIndex].xfdfString = xfdfString;
  },
  AddAnnotation(state, { cardId, relatedCollectionId, annotationId, xfdfString }) {
    const cardIndex = state.webViewerFileData.findIndex(entry => entry.cardId === cardId);
    state.webViewerFileData[cardIndex].annots.push({ cardId, relatedCollectionId, annotationId, xfdfString });
  },
  StartedProcessingFile(state, cardId) {
    state.processingFiles.push(cardId);
  },
  DoneProcessingFile(state, cardId) {
    const index = state.processingFiles.findIndex(id => id === cardId);
    state.processingFiles.splice(index, 1);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
